import React from 'react'

// Edge + Stack used to draw a gray "border ring" and a recursive stacked-card
// effect behind each card. With the new floating-shadow card surface there is
// no border to stack against, so both components are pass-throughs that keep
// the existing API stable for callers (PlaylistCard still passes stack={2}).
export const Edge = ({ children }) => <>{children}</>

export const Stack = ({ children }) => <>{children}</>
